const $inject = [];

const secondsToTimeFilter = () => {
  return function (seconds) {
    if (typeof seconds !== 'number' || seconds < 0) {
      return '1 mins';
    }

    const hours = Math.floor(seconds / 3600);
    const mins = Math.ceil((seconds % 3600) / 60);
    const times = [];

    if (hours) {
      times.push(`${hours} h`);
    }

    if (mins) {
      times.push(`${mins} min`);
    }

    if (times.length === 0) {
      times.push(`1 min`);
    }

    return times.join(' ');
  };
};

secondsToTimeFilter.$inject = $inject;

export default secondsToTimeFilter;



// WEBPACK FOOTER //
// ./src/filters/secondsToTimeFilter.js